import React, { Fragment, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useQuery from '../../hooks/useQuery'
import { Form, Card, Button, Row, Col, Table, Badge, Modal } from 'react-bootstrap'
import UserModal from './UserModal'
import ViewOrder from './ViewOrder'
import Pagination from '../../components/Nav/Pagination'
import config from '../../config'
import axios from 'axios'
import Cookies from 'js-cookie'
import moment from 'moment'
import BannedUserLogs from './components/BannedUserLogs'
import Colors from '../../constants/Colors'

const User = () => {
  const query = useQuery()
  const dispatch = useDispatch()

  const [users, setUsers] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [selectedUser, setSelectedUser] = useState({})
  const [userModalVisible, setUserModalVisible] = useState(false)
  const [showViewOrder, setShowViewOrder] = useState(false)
  const [userName, setUserName] = useState('')
  const [userIdOrPhone, setUserIdOrPhone] = useState(query.get('userIdOrPhone') ? query.get('userIdOrPhone') : '')
  const [phone, setPhone] = useState('')
  const [userId, setUserId] = useState('')
  const [forceUpdate, setForceUpdate] = useState(false)
  const [showModalToSendLine, setShowModalToSendLine] = useState(false)
  const [sendLineToUser, setSendLineToUser] = useState({
    name: '',
    lineName: '',
    lineId: '',
  })
  const [isDisplayBannedUserLogs, setIsDisplayBannedUserLogs] = useState(false)

  const fetchUsers = async (_query = {}) => {
    try {
      dispatch({ type: 'loading_show' })
      const query = {
        ..._query,
        name: userName,
        userId: userIdOrPhone,
        phone: phone,
      }
      const res = await axios.get(`${config.apiAdminGateway}/api/v1/admin/users`, {
        params: query,
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })

      const {
        status: { code, description },
        data,
      } = res.data

      if (code !== 0) {
        throw new Error(description)
      }
      setUsers(
        data.map((d) => {
          const bd = new Date(d.birthDay)
          return {
            ...d,
            birthDay: { year: bd.getFullYear(), month: bd.getMonth() + 1, day: bd.getDate() },
            ownerBankName: d.bankName,
            ownerBankNo: d.bankNo,
          }
        }),
      )
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      setUsers([])
      dispatch({ type: 'loading_hide' })
    }
  }

  useEffect(() => {
    fetchUsers()
    setCurrentPage(1)
  }, [forceUpdate])

  const onChangePage = (page, requestQuery) => {
    setCurrentPage(page)
    fetchUsers({ page })
  }

  const onShowSendMessage = (user) => {
    setSendLineToUser(user)
    setSelectedUser(user)
    setShowModalToSendLine(true)
  }

  const onSendMessage = async (message) => {
    try {
      dispatch({ type: 'loading_show' })

      const response = await fetch(`${config.apiAdminGateway}/api/v2/admin/notification/line`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        body: JSON.stringify({
          message,
          userId: selectedUser.id,
        }),
      }).then((res) => res.json())

      if (response.status.code !== 0) {
        throw new Error(response.status.description)
      }

      alert('ส่งข้อความสำเร็จ')
    } catch (err) {
      alert('ส่งข้อความล้มเหลว')
    } finally {
      dispatch({ type: 'loading_hide' })
      setShowModalToSendLine(false)
      setSendLineToUser({ name: '', lineName: '', lineId: '' })
      setSelectedUser({})
    }
  }

  const displaySearch = () => {
    return (
      <Form>
        <Form.Group>
          <Row>
            <Col sm={12} md={6} lg={4}>
              <input
                className="form-control"
                style={{ color: Colors.DARK_GREY }}
                type="text"
                placeholder="ชื่อลูกค้า"
                onChange={(e) => {
                  setUserName(e.target.value)
                }}
                onFocus={() => {
                  setPhone('')
                  setUserIdOrPhone('')
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    onChangePage(1, {})
                  }
                }}
                defaultValue={userName}
                value={userName}
              />
            </Col>
            <Col sm={12} md={6} lg={2}>
              <input
                className="form-control"
                style={{ color: Colors.DARK_GREY }}
                type="text"
                placeholder="รหัสสมาชิก"
                onChange={(e) => {
                  setUserIdOrPhone(e.target.value.toLocaleUpperCase())
                }}
                onFocus={() => {
                  setPhone('')
                  setUserName('')
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    onChangePage(1, {})
                  }
                }}
                defaultValue={userIdOrPhone}
                value={userIdOrPhone}
              />
            </Col>
            <Col sm={12} md={6} lg={2}>
              <input
                className="form-control"
                style={{ color: Colors.DARK_GREY }}
                type="text"
                placeholder="เบอร์โทร"
                onChange={(e) => {
                  setPhone(e.target.value)
                }}
                onFocus={() => {
                  setUserIdOrPhone('')
                  setUserName('')
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    onChangePage(1, {})
                  }
                }}
                defaultValue={phone}
                value={phone}
              />
            </Col>
            <Col sm={12} md={12} lg={4}>
              <Row>
                <Col md={6} lg={0}></Col>
                <Col md={6} lg={12}>
                  <Button
                    variant="danger light"
                    className="w-50"
                    onClick={() => {
                      setUserName('')
                      setUserIdOrPhone('')
                      setPhone('')
                      setForceUpdate((prevState) => !prevState)
                    }}
                  >
                    ล้างตัวกรอง
                  </Button>
                  <Button
                    variant="primary light"
                    className="w-50"
                    onClick={() => setForceUpdate((prevState) => !prevState)}
                  >
                    ค้นหา
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form.Group>
      </Form>
    )
  }

  const displayTableUser = () => {
    return (
      <Table responsive striped bordered className="verticle-middle">
        <thead>
          <tr>
            <th>รหัสลูกค้า</th>
            <th>ชื่อ-นามสกุล</th>
            <th>เบอร์โทรศัพท์</th>
            <th>วันที่สมัคร</th>
            <th>ชื่อไลน์</th>
            <th>คำสั่งซื้อ</th>
            <th>แชทไลน์</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, i) => {
            return (
              <tr key={i}>
                <td>
                  {user.banExpiredAt && moment(user.banExpiredAt).isAfter(moment()) ? (
                    <Badge
                      variant="danger light"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setSelectedUser(user)
                        setIsDisplayBannedUserLogs(true)
                      }}
                    >
                      <i className="icon-ban text-danger font-weight-bold" /> {user.userId}
                    </Badge>
                  ) : (
                    user.userId
                  )}
                </td>
                <td>
                  <Badge
                    variant="primary light"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setSelectedUser(user)
                      setUserModalVisible(true)
                    }}
                  >
                    {user.firstName} {user.lastName}
                  </Badge>
                </td>
                <td>{user.phone}</td>
                <td>{user.createdAt ? moment(user.createdAt).format('DD/MM/YY') : '-'}</td>
                <td>{user.name ? <Badge className="text-success">{user.name}</Badge> : ' - '}</td>
                <td>
                  <Badge
                    variant="danger light"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setShowViewOrder(true)
                      setUserId(user.userId)
                    }}
                  >
                    ดูคำสั่งซื้อ
                  </Badge>
                </td>
                <td>
                  {user.lineId ? (
                    <Badge
                      variant="success light"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        onShowSendMessage(user)
                      }}
                    >
                      เปิดแชทไลน์
                    </Badge>
                  ) : (
                    ' - '
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>ลูกค้า</Card.Title>
        </Card.Header>
        <Card.Body>
          {displaySearch()}
          {displayTableUser()}
          <Pagination
            currentPage={currentPage}
            onPrevPage={() =>
              onChangePage(currentPage - 1, {
                endItem: users[0].id,
              })
            }
            onNextPage={() =>
              onChangePage(currentPage + 1, {
                lastItem: users[users.length - 1].id,
              })
            }
            items={users}
            perPage={50}
          />
        </Card.Body>
        {userModalVisible && (
          <UserModal
            userModalVisible={userModalVisible}
            setUserModalVisible={setUserModalVisible}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            onClose={() => fetchUsers(currentPage)}
            users={users}
          />
        )}

        {showViewOrder && (
          <ViewOrder showViewOrder={showViewOrder} setShowViewOrder={setShowViewOrder} userIdOrPhone={userId} />
        )}

        {showModalToSendLine && (
          <ModalSendLine
            showModalToSendLine={showModalToSendLine}
            setShowModalToSendLine={setShowModalToSendLine}
            user={sendLineToUser}
            onSendMessage={onSendMessage}
          />
        )}

        {isDisplayBannedUserLogs && (
          <BannedUserLogs
            user={selectedUser}
            isDisplayBannedUserLogs={isDisplayBannedUserLogs}
            setIsDisplayBannedUserLogs={setIsDisplayBannedUserLogs}
          />
        )}
      </Card>
    </Fragment>
  )
}

const ModalSendLine = (props) => {
  const { showModalToSendLine, setShowModalToSendLine, user, onSendMessage } = props
  const [message, setMessage] = useState('')

  return (
    <Modal show={showModalToSendLine} centered>
      <Modal.Header>ทักแชทไลน์</Modal.Header>
      <Modal.Body>
        ชื่อลูกค้า: {user.firstName} {user.lastName} ({user.name})
        <textarea
          style={{ color: Colors.DARK_GREY }}
          placeholder="ข้อความที่ต้องการส่ง"
          rows={3}
          className="form-control mt-2"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger light" onClick={() => setShowModalToSendLine(false)}>
          ยกเลิก
        </Button>
        <Button
          variant="primary light"
          onClick={async () => {
            await onSendMessage(message)
            setMessage('')
          }}
        >
          ส่งข้อความ
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
export default User
